// This file is auto-generated by typhoon/scripts/export_js_enums.py

export enum ContentIdentifiers {
    CreateEditInvitationEventDetails = 'create_edit_invitation_event_details',
    CreateEditInvitationCreateDesign = 'create_edit_invitation_create_design',
    CreateEditInvitationEventGifting = 'create_edit_invitation_event_gifting',
    CreateEditInvitationReview = 'create_edit_invitation_review',
    CreateEditInvitationGuests = 'create_edit_invitation_guests',
    CreateEditInvitationUpsellPage = 'create_edit_invitation_upsell_page',
    UpsellModalStep1Copy = 'upsell_modal_step-1-copy',
    UpsellModalRemoveAds = 'upsell_modal_remove-ads',
    UpsellModalGifting = 'upsell_modal_gifting',
    UpsellModalHostPhotoGallery = 'upsell_modal_hostPhotoGallery',
    UpsellModalStep4Copy = 'upsell_modal_step-4-copy',
}
